





































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import uuid from "uuid/v4";
import { INPUT_TYPES, TemplateInput } from "@/store/template/types";
import DependencyInput from "./DependencyInput.vue";
import DependencyTile from "./DependencyTile.vue";
import ColumnInput from "./ColumnInput.vue";
import ColumnTile from "./ColumnTile.vue";
import SelectOption from "./SelectOption.vue";
import SelectTile from "./SelectTile.vue";

@Component({
  components: {
    DependencyInput,
    DependencyTile,
    ColumnInput,
    ColumnTile,
    SelectOption,
    SelectTile
  }
})
export default class NewInputDialog extends Vue {
  store = this.$store.direct;

  @Prop() sectionIndex!: number;
  @Prop() inputIndex!: number;
  @Prop() input!: TemplateInput;

  open = false;
  valid = false;

  master: Partial<TemplateInput> = {
    id: uuid(),
    name: "",
    type: "text",
    size: 12,
    readonly: false,
    required: true,
    headers: [],
    options: [],
    depends_on: []
  };

  rules = {
    required: (v: any) => !!v || "Este campo es obligatorio",
    unique: (v: string) =>
      this.input && this.input.name == v
        ? true
        : !this.variables.includes(v.toLowerCase()) ||
          "El nombre " + v + " se encuentra en uso"
  };

  get inputTypes() {
    return INPUT_TYPES;
  }

  get variables() {
    let local: string[] = [];
    if (this.master.headers) {
      this.master.headers.forEach(header => {
        local.push(header.name.toLowerCase());
      });
    }
    return this.store.getters.template.usedVariables.concat(local);
  }

  init() {
    if (this.input) {
      this.master = { ...this.input };
    } else {
      this.master = {
        id: uuid(),
        name: "",
        type: "text",
        label: "",
        placeholder: "",
        size: 12,
        readonly: false,
        required: true,
        headers: [],
        options: [],
        depends_on: []
      };
    }
  }

  save() {
    if (this.valid) {
      if (this.input) {
        this.store.commit.template.UPDATE_INPUT_FROM_SECTION({
          input: this.master as TemplateInput,
          inputIndex: this.inputIndex,
          section: this.sectionIndex
        });
      } else {
        this.store.commit.template.ADD_INPUT_TO_SECTION({
          input: this.master as TemplateInput,
          section: this.sectionIndex
        });
      }
      this.open = false;
    }
  }

  toggleOpen() {
    this.open = !this.open;
  }

  @Watch("open")
  onOpenChange(newVal: boolean, oldVal: boolean) {
    if (newVal) {
      this.init();
    }
  }
}
